import * as React from 'react';
import { useState, createContext, useContext } from 'react';
import { ObjBeteckningslista } from '../model/KartstodModel';

interface DataContextTyp {
  listaBeteckningsObjekt: ObjBeteckningslista[];
  setListaBeteckningsObjekt: (
    objBeteckningslista: ObjBeteckningslista[]
  ) => void;
  klickFranKarta: string;
  setKlickFranKarta: (objektID: string) => void;
}

const DataContext = createContext<DataContextTyp | undefined>(undefined);

type DataContextProviderProps = { children: React.ReactNode };

function DataProvider({ children }: DataContextProviderProps) {
  const [listaBeteckningsObjekt, setListaBeteckningsObjekt] = useState<
    ObjBeteckningslista[]
  >([]);
  const [klickFranKarta, setKlickFranKarta] = useState<string>('');

  const value = {
    listaBeteckningsObjekt,
    setListaBeteckningsObjekt,
    klickFranKarta,
    setKlickFranKarta,
  };

  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
}

function useDataContext() {
  const context = useContext(DataContext);
  if (context === undefined) {
    throw new Error('React must be used within a DataContextProvider');
  }
  return context;
}

export { DataProvider, useDataContext };
